import React from 'react';

/**
 * A generic interface that tells the node panel component to display the error when required fields are missing.
 */

interface IProps {
    subtitle?: string;
    elements?: {
        key?: string;
        component: () => JSX.Element | null; // inject extra props into the panel element
        isRequired?: boolean;
        isHidden?: boolean;
        validate?: () => boolean;
    }[];
    className?: string;
}

export const NodePanelBase = (props: IProps) => {
    return (
        <div className={`workflow-node-panel ${props.className || ''}`.trim()}>
            {props.subtitle && <p>{props.subtitle}</p>}

            {(props.elements || []).map((element, i) => (
                <section
                    key={element.key || `node-panel-element-${i}`}
                    data-testid='node-panel-section-element'
                    className='workflow-node-panel-section'
                    style={{ display: element.isHidden ? 'none' : 'block' }}
                >
                    {element.component()}
                </section>
            ))}
        </div>
    );
};
